import { withIdleTimer } from 'react-idle-timer';

const IdleTimerComponent = () => { return null };

export const IdleTimer = withIdleTimer(IdleTimerComponent);